import { GradientTextAction } from 'src/common';
import styled, { css } from 'styled-components';

export const Label = styled(GradientTextAction)<{ $disabled: boolean }>`
  cursor: inherit;
  ${({ $disabled }) =>
    $disabled &&
    css`
      color: ${({ theme }) => theme.colors.cflowerBlue};
      cursor: default;
    `}
`;
